import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import {useLeftyTemplate} from 'Event/template/Lefty'
import Title from 'lib/ui/ConfigPanel/Title'
import Select from 'lib/ui/Select'
import Option from 'lib/ui/Select/Option'
import {onUnknownChangeHandler} from 'lib/dom'

export const WELCOME_TEXT_ALIGN_LEFT = 'Left'
export const WELCOME_TEXT_ALIGN_CENTER = 'Center'
export const WELCOME_TEXT_ALIGN_RIGHT = 'Right'

export type WELCOME_TEXT_ALIGN =
  | typeof WELCOME_TEXT_ALIGN_LEFT
  | typeof WELCOME_TEXT_ALIGN_CENTER
  | typeof WELCOME_TEXT_ALIGN_RIGHT

const WELCOME_TEXT_ALIGNS: WELCOME_TEXT_ALIGN[] = [
  WELCOME_TEXT_ALIGN_LEFT,
  WELCOME_TEXT_ALIGN_CENTER,
  WELCOME_TEXT_ALIGN_RIGHT,
]

export default function Styling(props: {control: UseFormMethods['control']}) {
  const {control} = props
  const template = useLeftyTemplate()

  return (
    <>
      <Title>Layout</Title>
      <Controller
        name="welcomeTextAlign"
        defaultValue={template.welcomeTextAlign}
        control={control}
        render={({value, onChange}) => (
          <Select
            fullWidth
            label="Text Align"
            value={value}
            onChange={onUnknownChangeHandler(onChange)}
          >
            {WELCOME_TEXT_ALIGNS.map((align) => (
              <Option value={align}>{align}</Option>
            ))}
          </Select>
        )}
      />
    </>
  )
}
